export default class CharacterDragged extends Phaser.Image {
  constructor(game, x, y, characterId, slotRef, clothSlotRef, clothId) {
    super(game, x, y);

    this.characterId = characterId;
    this.slotRef = slotRef;
    this.clothSlotRef = clothSlotRef;
    this.clothId = clothId;

    //
    this.character = this.game.make.spine(0, 0, characterId, true);

    this.character.setAnimationByName(0, 'picked up', true);
    this.character.skeleton.getRootBone().scaleX = 0.4;
    this.character.skeleton.getRootBone().scaleY = 0.4;
    this.character.anchor.set(0.5, 0.8);
    this.addChild(this.character);

    this.update();
    this.updateTransform();

    // cloth
    if (this.clothId > -1) {
      this.wearCloth();
    } else {
      this.character.setSkinByName('base');
    }

    // interactions
    this.inputEnabled = true;
    this.input.enabled = true;
    this.game.input.onUp.add(this.onReleaseMe, this);
    this.checkWorldBounds = true;

    // twins
    if (characterId === 'twins') {
      this.twin = new CharacterDragged(this.game, 50, 0, 'mary', null, null, clothId);
      this.twin.inputEnabled = false;
      this.addChild(this.twin);
    }
  }

  startDrag(pointer) {
    this.pointer = pointer;
    this.isDragging = true;
    this.dx = this.x + this.parent.x - pointer.x;
    this.dy = this.y + this.parent.y - pointer.y;
    // this.input.startDrag(pointer);
  }

  onReleaseMe(pointer) {
    if (this.pointer !== pointer) {
      return;
    }

    //
    this.input.enabled = false;
    this.input.disableDrag();

    //
    this.game.input.onUp.remove(this.onReleaseMe, this);

    //
    this.game.state.getCurrentState().stopDragCharacter(this);

    //
    this.destroy();
  }

  update() {
    if (this.isDragging) {
      const pointer = this.game.input.position;
      this.x = pointer.x + this.dx - this.parent.x;
      this.y = pointer.y + this.dy - this.parent.y;
    }

    this.character.update();

    if (this.twin) {
      this.twin.update();
    }

    super.update();

    // detect out of screen
    if (this.isDragging && this.pointer && !this.pointer.withinGame) {
      this.onReleaseMe(this.pointer);
    }
  }

  wearCloth() {
    const clothData = this.game.controller.gameData.clothes.find((d) => d.id === this.clothId);
    // apply new oufit
    if (clothData && clothData.wearable) {
      this.character.setSkinByName(clothData.skin_name);

      const rb = this.character.skeleton.getRootBone();
      const x0 = rb.scaleX;
      const y0 = rb.scaleY;
      this.character.setToSetupPose();
      rb.scaleX = x0;
      rb.scaleY = y0;

      this.updateTransform();
      this.update();
    }
  }

  destroy() {
    this.twin = null;
    super.destroy();
  }
}
